import { useMemo } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { TicketApi } from "../services";
import { TICKET_STATUS } from "../pages/Tickets/meta";

/* Counts support tickets that support has answered and the user hasn't opened
 * since. Kept local on purpose — like the chat unread badge, the panel decides
 * what counts as "seen" from the last reply timestamp it already receives with
 * the ticket list, so no extra endpoint is needed. */
const ANSWERED = Number(
  Object.keys(TICKET_STATUS).find((key) => TICKET_STATUS[key].key === "answered"),
);

const POLL_MS = 60000;

export const useTicketUnread = (enabled = true) => {
  const seen = useSelector(({ common }) => common.ticketsSeen);

  const { data: tickets } = useQuery({
    queryKey: ["[List] Tickets Unread"],
    queryFn: () =>
      TicketApi.getTickets({ params: { per_page: 50 } }).then(
        (result) => result.data.tickets?.data ?? [],
      ),
    initialData: [],
    enabled,
    refetchInterval: POLL_MS,
    refetchOnWindowFocus: true,
    staleTime: POLL_MS,
  });

  return useMemo(
    () =>
      (tickets ?? []).filter(
        (ticket) =>
          ticket.status === ANSWERED &&
          ticket.last_reply_at &&
          seen?.[ticket.uuid] !== ticket.last_reply_at,
      ).length,
    [tickets, seen],
  );
};

export default useTicketUnread;
